import { Link } from 'react-router-dom';
import { Button, List, Skeleton } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useGetRelationGroupByIdQuery } from 'services';

/**
 * Grup ID'si ile grup detayını çekip üyelerini listeleyen popover içeriği.
 * @param {Object} props
 * @param {number} props.groupId - Grubun ID'si
 * @param {Function} props.onEdit - Edit butonuna tıklandığında çağrılacak callback
 */
function PopoverContent({ groupId, onEdit }) {
  const { data: group, isLoading } = useGetRelationGroupByIdQuery({ groupId });

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 3 }} style={{ width: 250 }} />;
  }

  if (!group) return null;

  return (
    <div style={{ maxWidth: '300px' }}>
      <div
        className="gx-mb-2 gx-mt-2 gx-p-2 gx-d-flex gx-align-items-center gx-justify-content-between"
        style={{ fontWeight: 'bold', borderBottom: '1px solid #f0f0f0' }}
      >
        <h2 style={{ fontSize: '16px' }}>{group.name}</h2>
        <Button
          icon={<EditOutlined />}
          size="small"
          shape="circle"
          type="text"
          onClick={onEdit}
        />
      </div>
      <List
        size="small"
        dataSource={group.members}
        renderItem={(member, memberIndex) => (
          <List.Item
            key={member.id || memberIndex}
            className="gx-mt-2 gx-mb-2"
          >
            <Link
              to={`/madde-detay/${member.articleOffer.id}`}
              target="_blank"
              rel="noreferrer noopener"
            >
              <span className="gx-mr-2">{memberIndex + 1}.</span>
              {member.articleOffer.title}
            </Link>
          </List.Item>
        )}
      />
    </div>
  );
}

export default PopoverContent;
